import {useMutation} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {SeedQuestion, SeedQuestionSource, SeedQuestionStatus} from '@cp/model';
import {UPDATE_SEED_QUESTION} from '../sharedQueries';

export function useUpdateSeedQuestion() {
  const [updateSeedQuestionMutation, {loading, error}] = useMutation<
    {updateSeedQuestion: SeedQuestion},
    {
      moduleId: string;
      seedQuestionId: string;
      questionText?: string;
      topic?: string;
      options?: string[];
      answer?: string;
      source?: SeedQuestionSource;
      status?: SeedQuestionStatus;
    }
  >(UPDATE_SEED_QUESTION);

  const updateSeedQuestion = async (
    moduleId: string,
    seedQuestionId: string,
    questionText?: string,
    topic?: string,
    options?: string[],
    answer?: string,
    source?: SeedQuestionSource,
    status?: SeedQuestionStatus,
  ) => {
    const result = await updateSeedQuestionMutation({
      variables: {
        moduleId,
        seedQuestionId,
        questionText,
        topic,
        options,
        answer,
        source,
        status,
      },
    });

    return extractGqlData(result).updateSeedQuestion;
  };

  return {
    updateSeedQuestion,
    loading,
    error,
  };
}
